import React, {PropTypes} from 'react';
import _ from 'lodash';

export default class SessionListItem extends React.Component {

  render() {

    return (
      <tr>
        <td>
            <div className="vcenter">{_.upperFirst(this.props.data.screen)}</div>
        </td>
        <td>
            <div className="vcenter">{this.props.data.hits}</div>
        </td>
      </tr>
    );
  }
}
